/**
 * BrandLogo - Law Agency 360
 * A 360° ring (open at 12 o'clock) with a stylised "LA" monogram inside.
 *
 * NOTE: all SVG children are STATIC (no inline `{cond && <el/>}`), because the
 * visual-editor instrumentation wraps conditional JSX in an HTML <span>, which
 * breaks SVG paint servers (gradient) and makes the plate render transparent.
 */
import { useId } from 'react';

export default function BrandLogo({
  size = 40,
  withText = false,
  variant = 'gradient',
  className = '',
  textClassName = '',
}) {
  const uid = useId().replace(/:/g, '');
  const gradId = `lawagency360-grad-${variant}-${uid}`;

  if (variant === 'mono') {
    return (
      <div className={`inline-flex items-center gap-2.5 ${className}`}>
        <svg width={size} height={size} viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" className="flex-shrink-0" aria-label="Law Agency 360 logo">
          <circle cx="24" cy="24" r="17" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeDasharray="80 12" transform="rotate(-95 24 24)" />
          <circle cx="24" cy="7" r="1.6" fill="currentColor" />
          <g fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M18 17 L18 30 L23 30" />
            <path d="M26 30 L29.5 18.5 L33 30" />
            <path d="M27.6 26 L31.4 26" />
          </g>
        </svg>
        {withText ? (
          <span className={`font-bold tracking-tight ${textClassName || 'text-white'}`} style={{ fontFamily: 'Outfit, system-ui, sans-serif' }}>
            Law Agency 360
          </span>
        ) : null}
      </div>
    );
  }

  return (
    <div className={`inline-flex items-center gap-2.5 ${className}`}>
      <svg width={size} height={size} viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" className="flex-shrink-0" aria-label="Law Agency 360 logo">
        <defs>
          <linearGradient id={gradId} x1="0" y1="0" x2="48" y2="48" gradientUnits="userSpaceOnUse">
            <stop offset="0%" stopColor="#8B5CF6" />
            <stop offset="55%" stopColor="#7C3AED" />
            <stop offset="100%" stopColor="#4F46E5" />
          </linearGradient>
        </defs>
        <rect x="0" y="0" width="48" height="48" rx="12" fill={`url(#${gradId})`} />
        <circle cx="24" cy="24" r="14.5" fill="none" stroke="#FFFFFF" strokeWidth="2.2" strokeLinecap="round" strokeDasharray="80 12" transform="rotate(-95 24 24)" opacity="0.95" />
        <circle cx="24" cy="9.5" r="1.6" fill="#A78BFA" />
        <g fill="none" stroke="#FFFFFF" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M18 17 L18 30 L23 30" />
          <path d="M26 30 L29.5 18.5 L33 30" />
          <path d="M27.6 26 L31.4 26" />
        </g>
      </svg>
      {withText ? (
        <span className={`font-bold tracking-tight ${textClassName || 'text-white'}`} style={{ fontFamily: 'Outfit, system-ui, sans-serif' }}>
          Law Agency 360
        </span>
      ) : null}
    </div>
  );
}
